import React, { cloneElement } from 'react';
import { useListContext, TopToolbar, sanitizeListRestProps } from 'react-admin';
import useDataProviderWrapper from 'hooks/dataProviderWrapper';
import { ActionButton } from 'Components';
import { AddOutlined, CloudUpload } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';

const EvidenceActions = (props) => {
  const { className, exporter, filters, maxResults, ...rest } = props;
  const { resource, displayedFilters, filterValues, showFilter, basePath } =
    useListContext();
  const callToDataProvider = useDataProviderWrapper();
  const history = useHistory();

  const onUpload = (event) => {
    // return callToDataProvider({
    //   type: 'EXPORT',
    //   resource: 'review',
    //   payload: {
    //     data: {
    //       filter: {
    //         ...filterValues, // pass the current filter values to the export request
    //       },
    //     },
    //   },
    //   onSuccess: (url) => downloadFile(url),
    // });
  };

  const onCreateButton = () => {
    history.push('/evidence/create');
  };

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      <ActionButton
        icon={<AddOutlined />}
        variant="text"
        label="Create"
        onClick={onCreateButton}
      />
    </TopToolbar>
  );
};

export default EvidenceActions;
